import { ChangeDetectorRef, Directive, effect, ElementRef, HostBinding, inject, input, linkedSignal, signal } from '@angular/core';

@Directive()
export class MenuItemWrapper {

    @HostBinding('attr.role') role = 'listitem';
    @HostBinding('style.display') display = 'contents';

    changeDetectorRef = inject(ChangeDetectorRef);

    $isSelected = input(false, { alias: 'isSelected' });
    $isDisabled = input(false, { alias: 'isDisabled' });

    $_isSelected = linkedSignal(() => this.$isSelected());
    $showItem = signal(true);

    elementRef: ElementRef<HTMLElement> = inject(ElementRef);

    constructor() {
        effect(() => {
            this.display = this.$showItem() ? 'contents' : 'none';
            this.changeDetectorRef.markForCheck();
        });
    }

}
